import { render, staticRenderFns } from "./HeaderModular.vue?vue&type=template&id=1f95cfb8&scoped=true&"
import script from "./HeaderModular.vue?vue&type=script&lang=js&"
export * from "./HeaderModular.vue?vue&type=script&lang=js&"
import style0 from "./HeaderModular.vue?vue&type=style&index=0&id=1f95cfb8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f95cfb8",
  null
  
)

export default component.exports